var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWithdrawalIconMenu = function SvgWithdrawalIconMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-slot": "withdrawal-icon-menu",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    color: "#fff"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#withdrawal-icon-menu_svg__clip0_4482_7768)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.19c-4.36 0-8.26-2.61-9.93-6.64C.4 11.53 1.31 6.93 4.4 3.84c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06a9.221 9.221 0 0 0-2 10.08A9.22 9.22 0 0 0 12 20.69a9.21 9.21 0 0 0 8.54-5.71c1.44-3.47.65-7.42-2-10.08a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0 3.08 3.08 4 7.68 2.33 11.71A10.725 10.725 0 0 1 12 22.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 .69c.41 0 .75.34.75.75v10c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-10c0-.41.34-.75.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 .69c.19 0 .38.07.53.22l3.33 3.33c.29.29.29.77 0 1.06-.29.29-.77.29-1.06 0L12 2.5 9.2 5.3c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06L11.47.91c.15-.15.34-.22.53-.22Z"
  }))));
};
export default SvgWithdrawalIconMenu;